module.exports = __webpack_public_path__ + "img/10953@3x.0fa93eb8.png";